import * as Yup from 'yup';

/**
 * French mobile numbers (06/07, +336/+337, 00336/00337), separators tolerated on input.
 * Single source for the three forms that collect a mandate signatory's mobile: firm
 * creation (gerantFields), "declare the manager" panel and the mandate sending panel.
 */
export const FRENCH_MOBILE_PATTERN = /^(?:(?:\+|00)33|0)\s*[67](?:[\s.-]*\d{2}){4}$/;

export const isFrenchMobile = (value: string): boolean => FRENCH_MOBILE_PATTERN.test(value.trim());

/**
 * The backend's [FrenchMobilePhoneNumber] attribute matches `^(\+33|0)[67]\d{8}$` on the
 * raw value, without stripping separators: send the canonical form or get a 400.
 * "06 12 34 56 78" → "0612345678", "00 33 6 12 34 56 78" → "+33612345678".
 */
export const normalizeFrenchMobile = (value: string): string =>
  value.replace(/[\s.-]/g, '').replace(/^00/, '+');

/** Yup rule for a mobile field; `required` carries the message when the field is mandatory. */
export const frenchMobileRule = (invalidMessage: string, required?: string) => {
  const rule = Yup.string().test('french-mobile', invalidMessage, (v) => !v || isFrenchMobile(v));
  return required ? rule.required(required) : rule;
};
